var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.64 30.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #add59e;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    className: "cls-1",
    d: "M19.69,25.43c14.08,2.22,18.77-10.84,19.56-19.09.01-.61-.47-1.12-1.09-1.13-.13,0-.27.02-.4.06-4.34,1.52-9.1,1.26-13.24-.73-1.39-.68-2.88-1.11-4.41-1.28-5.5-.53-9.52,6.14-9.57,11.77,0,.3.26.53.55.52.1,0,.2-.04.29-.09,1.68-1.16,3.72-1.68,5.75-1.47,4.36.64,8.18-.98,10.68-1.71.9-.26,1.65.69.93,1.29-1.89,1.53-4.23,2.41-6.66,2.49-.77.04-1.55.02-2.32,0-1.65-.13-3.31.02-4.91.46-1.31.45-2.56,1.04-3.74,1.76-1.9,1.43-4.34,2.58-7.5,7.06-.27.37-.33.86-.16,1.29.23.55.77.9,1.37.89.41.05.93-.52,1.23-.85,3.1-3.39,3.76-4.59,6.84-5.93,1.64,2.31,4.04,3.96,6.78,4.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.2db66fcfe4bdfced6dafeec9c2a03496.svg";
export { ForwardRef as ReactComponent };